$(document).ready(function() {
  // $('table#variant-table').on('click', '.remove-variant', function() {
  //   var elTr = $(this).parents('tr');
  //   var elTody = elTr.parents('tbody');

  //   // REMOVE TR ELEMENT
  //   elTr.remove();
  //   if (elTody.find('tr').length == 1) {
  //     var lastTr = elTody.find('tr')

  //     // REMOVE BUTTON FOR LAST VARIANT
  //     lastTr.find('button.remove-variant').remove()
  //   }
  // })

  $('table#variant-table').on('click', '.destroy-variant', function() {
    var elTr = $(this).parents('tr');
    var _destroy = elTr.find('input._destroy_variant');

    // MAKE VALUE TRUE, SO WHEN RECORD SAVED VARIANT WILL BE REMOVED
    _destroy.val(true)
    elTr.addClass('d-none')
    if (elTr.parents('tbody').find('tr:not(.d-none)').length == 1) {
      var lastTr = elTr.parents('tbody').find('tr:not(.d-none)')

      // DISABLED BUTTON FOR LAST VARIANT
      lastTr.find('button.destroy-variant').attr('disabled', true)
      lastTr.find('button.destroy-variant').attr('data-tooltip', 'tooltip')
      lastTr.find('button.destroy-variant').attr('data-placement', 'top')
      lastTr.find('button.destroy-variant').attr('title', I18n.t('global.alerts.you_cant_remove_default_or_last_variant'))
    }
  })

  // DEAFULT CANNOT COMBINE WITH CUSTOM VARIANT
  $('.variant-checkbox.default-v').on('change', function() {
    if ($(this).prop('checked')) {
      $('.variant-checkbox.custom-v').prop('checked', false)
      $('.variant-checkbox.default-v').attr('disabled', true)
    }
  })

  $('.variant-checkbox.custom-v').on('change', function() {
    $('.variant-checkbox.default-v').removeAttr('disabled')

    if ($(this).prop('checked')) {
      $('.variant-checkbox.default-v').prop('checked', false)
    } else {
      if ($('.variant-checkbox.custom-v:checked').length == 0) {
        $('.variant-checkbox.default-v').prop('checked', false)
        $('.variant-checkbox.default-v').attr('disabled', true)
      }
    }
  })
  // DEAFULT CANNOT COMBINE WITH CUSTOM VARIANT -- END CODE
})